/**
 * safeTrack.ts
 *
 * Non-blocking wrapper for analytics/telemetry calls.
 * Replaces bare .catch(() => {}) with structured warn logging
 * so failures are visible in browser devtools and server logs
 * without ever throwing to the caller.
 *
 * Usage:
 *   safeTrack(() => trackSomeEvent(params), "context_label")
 *   // or fire-and-forget a promise:
 *   void safeTrack(() => Promise.resolve(someAsyncTracking()), "label")
 */
export function safeTrack(fn: () => void | Promise<void>, label = "analytics"): void {
  try {
    const result = fn();
    if (result && typeof result === "object" && "catch" in result) {
      (result as Promise<void>).catch((err: unknown) => {
        const msg = err instanceof Error ? err.message : String(err);
        console.warn(`[safeTrack:${label}] non-critical failure:`, msg);
      });
    }
  } catch (err) {
    const msg = err instanceof Error ? err.message : String(err);
    console.warn(`[safeTrack:${label}] non-critical failure:`, msg);
  }
}
